// UserForm.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import axios from 'axios';
import './UserForm.css';
import AuthContext from './AuthContext'; // Import the AuthContext

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const UserForm = () => {
  const navigate = useNavigate();
  const { dataUser } = useOutletContext();
  const { customerId } = useParams();
  const { userId } = useParams();
  const { user } = useContext(AuthContext); // Use the AuthContext
  const [formData, setFormData] = useState({
    title: "",
    person_Name: "",
    email: "",
    login: "",
    password: "", // Empty by default
    user_role: "3",
    active: "Yes",
  });

  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    number: false,
    uppercase: false,
    symbol: false,
    noSpaces: true,
  });

  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [isPasswordRequired, setIsPasswordRequired] = useState(false);
  const [originalPasswordState, setOriginalPasswordState] = useState(""); // Stores initial password state

  useEffect(() => {
    
  }, [user, navigate]);

  useEffect(() => {
    console.log("User object:", user);
    if (!user) {
      setError('User is not authenticated.');
      navigate('/login');
        return;
      }
      // check expiration
      const currentTime = Date.now() / 1000; // in seconds
      if (user.exp && user.exp <= currentTime) {
        // token has expired
        navigate('/login');
      }
            
    if (userId && !dataUser) return;

    if (dataUser && dataUser.length) {
      try {
        const isElevated = user?.role_name === 'Admin' || user?.role_name === 'SuperAdmin';
        if (!isElevated && dataUser[0].id !== parseInt(userId, 10)) {
          throw new Error("Accessing an incorrect user id.");
        }
      } catch (error) {
        setError(error);
      }

      setFormData({
        title: dataUser[0].title || '',
        person_Name: dataUser[0].person_Name || '',
        email: dataUser[0].email || '',
        login: dataUser[0].login || '',
        password: '', // Keep empty on initial load
        user_role: String(dataUser[0].user_Role) || "3",
        active: dataUser[0].active || 'Yes',
      });
    } else if (userId && (!dataUser || dataUser.length === 0)) {
      setError('The requested user does not exist.');
    } else if (dataUser.result && dataUser.result.error) {
      if (dataUser.result.error.indexOf("Unauthorized Access"))
        setError("Unauthorized Access");
    }
  }, [userId, dataUser, navigate]);

  const validatePassword = (password) => {
    const length = password.length >= 10;
    const number = /\d/.test(password);
    const uppercase = /[A-Z]/.test(password);
    const symbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const noSpaces = !/\s/.test(password);

    setPasswordValidation({ length, number, uppercase, symbol, noSpaces });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === 'password') {
      if (value) {
        setIsPasswordRequired(true); // Show validation when user starts typing
        validatePassword(value);
      } else {
        setIsPasswordRequired(false); // Hide validation if password is cleared
      }
    }
  };

  const handleCancelPassword = () => {
    setFormData((prevData) => ({
      ...prevData,
      password: originalPasswordState, // Reset password field
    }));
    setIsPasswordRequired(false); // Hide validation rules
  };

  const isPasswordValid = isPasswordRequired ? Object.values(passwordValidation).every((isValid) => isValid) : true;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isPasswordRequired && !isPasswordValid) {
      setError('Please fix the password validation errors.');
      return;
    }

    try {
      const payload = {
        ...formData,
        user_role: String(formData.user_role), // Convert user_role to a string
        customer_id: String(user.customer_id),
        id: userId,
      };
      const response = await apiClient.post(
        '/api/user/update',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      if (response && response.data && response.data.result && response.data.result.message) {
        console.log(response.data.result.message);
        var message = response.data.result.message;

        if (message.includes("ERROR")) {
          if (message.includes("Duplicate")) {
            setError('That username is unavailable.');
          } else {
            setError(message);
          }
        } else {
          setMessage(message);
        }
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('An error occurred while submitting the form.');
    }
  };

  if (userId && !dataUser) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (<div className="error">{error}</div>);
  } else {
    return (
      <form onSubmit={handleSubmit} className="user-form">
        {error && <div className="error">{error}</div>}
        {message && <div className="message">{message}</div>}
        <table className="tableMain" border="0" width="100%" cellPadding="2" cellSpacing="2">
          <tbody>
		  <tr>
            <td className="lbltxt">Title:</td>
            <td>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Person Name:</td>
            <td>
              <input
                type="text"
                name="person_Name"
                value={formData.person_Name}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Email:</td>
            <td>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="inputFull fieldsMed"
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Login:</td>
            <td>
            <span>{formData.login}</span>              
            </td>
          </tr>  
            <tr>
              <td className="lbltxt">Password:</td>
              <td>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className="inputFull fieldsMed"
                />
                {!isPasswordRequired && <p className="info-message">Leave blank if not updating password</p>}
                {isPasswordRequired && (
                  <div className="password-validation">
                    <ul>
                      <li className={passwordValidation.length ? 'valid' : 'invalid'}>
                        At least 10 characters
                      </li>
                      <li className={passwordValidation.number ? 'valid' : 'invalid'}>
                        At least 1 number
                      </li>
                      <li className={passwordValidation.uppercase ? 'valid' : 'invalid'}>
                        At least 1 uppercase letter
                      </li>
                      <li className={passwordValidation.symbol ? 'valid' : 'invalid'}>
                        At least 1 symbol (!@#$%^&*)
                      </li>
                      <li className={passwordValidation.noSpaces ? 'valid' : 'invalid'}>
                        No spaces
                      </li>
                    </ul>
                    <button type="button" onClick={handleCancelPassword} className="cancel-btn">Cancel</button>
                  </div>
                )}
              </td>
            </tr><tr>
            <td className="lbltxt">Access Level:</td>
            <td>
              {user.role_name === 'User' ? (
                // If user_Role = 1, show read-only text
                <span>{user.role_name}</span>
              ) : (
                // Otherwise, show the <select>
                <select
                  name="user_role"
                  value={String(formData.user_role)}
                  selected={String(formData.role_name)}
                  onChange={handleInputChange}
                  className="inputFull fieldsSm"
                >
                  { (user?.role_name === "Admin" || user?.role_name === "SuperAdmin") && <option value="3">User</option>}
                  { (user?.role_name === "Admin" || user?.role_name === "SuperAdmin")  && <option value="2">Customer Admin</option>}
                  { (user?.role_name === "SuperAdmin")  && <option value="1">Super Admin</option>}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Active:</td>
            <td>
              {user.role_name === 'User' ? (
                // If user_Role = 1, show read-only text
                <span>{formData.active}</span>
              ) : (
                // Otherwise, show the <select>
                <select
                  name="active"
                  value={formData.active}
                  onChange={handleInputChange}
                  className="inputFull fieldsSm"
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              )}
            </td>
          </tr>
            <tr>
              <td></td>
              <td>
                <button type="submit" disabled={!isPasswordValid} className="fieldsMed">
                  Update
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    );
  }
};

export default UserForm;
